document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".main-header");
  const main = document.querySelector("main");

  let lastScroll = 0;

  // Dynamisch Main-Abstand setzen
  function updateMainOffset() {
    const headerHeight = header.offsetHeight;
    main.style.marginTop = `${headerHeight - 1}px`;
  }

  updateMainOffset();
  window.addEventListener("resize", updateMainOffset);

  // Scroll-Handling
  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;

    // Scrollrichtung: nach unten → Header raus
    if (currentScroll > lastScroll && currentScroll > 80) {
      header.classList.add("hidden-up");
    } else {
      header.classList.remove("hidden-up");
    }

    // Schatten aktivieren
    if (currentScroll > 10) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }

    lastScroll = currentScroll;
  });
});
